import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ECookiesActionTypes, TCookiesAccepted } from './types';

export const cookiesAccepted: () => TCookiesAccepted = actionGenerator<ECookiesActionTypes.CookiesAccepted>(
  ECookiesActionTypes.CookiesAccepted,
);
